import React from 'react';
import { classes } from 'typestyle';
import {
    buttonClassName,
    buttonDefaultClassName,
    buttonLightClassName,
    buttonBlockClassName,
    buttonWhiteClassName,
    buttonDisabledClassName
} from './button.style';
import { useNavigate } from 'react-router-dom';

interface ButtonProps {
    onClick?(): void,
    link?: string,
    format?: ButtonFormat,
    block?: boolean,
    disabled?: boolean,
    children?: React.ReactNode,
    className?: string
}

type ButtonFormat = 'default' | 'light' | 'white';

const Button: React.FC<ButtonProps> = ({
    onClick,
    link,
    format = 'default',
    block = false,
    disabled,
    children,
    className
}) => {
    const navigate = useNavigate();

    return (
        <button
            type='button'
            disabled={ disabled }
            className={ classes(
                className,
                buttonClassName,
                (() => {
                    switch(format) {
                        case 'default': return buttonDefaultClassName;
                        case 'light': return buttonLightClassName;
                        case 'white': return buttonWhiteClassName;
                    }
                })(),
                block && buttonBlockClassName,
                disabled && buttonDisabledClassName,
            ) }
            onClick={ event => {
                event.preventDefault();
                
                if (!disabled) {
                    onClick && onClick();
                    link && navigate(link);
                }
            } }
            children={ children }/>
    );
};

export default Button;
